export const SAVE_APPOINTMENT_NOT_ATTENDED_STATUS = "SAVE_APPOINTMENT_NOT_ATTENDED_STATUS"
export const SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_FAIL = "SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_FAIL"
export const SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_SUCCESS = "SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_SUCCESS"
export const SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_RESET = "SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_RESET"

export const saveAppointmentNotAttendedStatus = (params) => {
    return { type: SAVE_APPOINTMENT_NOT_ATTENDED_STATUS, params }
}
export const saveAppointmentNotAttendedStatusFail = (response) => {
    return { type: SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_FAIL, response }
}
export const saveAppointmentNotAttendedStatusSuccess = (response) => {
    return { type: SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_SUCCESS, response }
}
export const saveAppointmentNotAttendedStatusReset = () => {
    return { type: SAVE_APPOINTMENT_NOT_ATTENDED_STATUS_RESET }
}